<template>
  <v-flex>
    <v-form v-model="valid">
      <v-text-field
        v-model="clientModel"
        :append-icon="'mdi-map-marker-off'"
        :rules="clientNameRules"
        label="Client"
      ></v-text-field>
    </v-form>
  </v-flex>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        loading: false,
        clientModel: null,
        clientNameRules: [
          v => {
            let rules = true

            if (!this.selectedClient) {
              rules = !!v || 'Required'
            }

            return rules
          }
        ],
        valid: false
      }
    },
    computed: {
      ...mapGetters({
        clientById: 'getClientById'
      })
    },
    watch: {
      valid (newVal) {
        this.$emit('valid:changed', newVal)
      },
      clientModel (name) {
        this.valid = true
        this.$emit('namechanged', name)
      },
      selectedClient (id) {
        this.$store.dispatch('getAllClients').then(() => {
          this.clientModel = this.clientById(id).name || this.clientById(id).text
        })
      }
    },
    props: {
      selectedClient: {
        required: false,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClientAddForm.vue?e89e62e0